module.exports = __webpack_public_path__ + "img/module.2a7235fc.svg";